<template>
  <!-- team_modal_start -->
  <b-modal content-class="modal-principal"
    v-model="showTeam"
    size="xl"
    @hide="onClose"
    no-close-on-backdrop
    hide-footer
  >
    <!-- ref="team" -->
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.Team.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div v-if="showLog" class="d-flex flex-column justify-content-start h-100">
      <b-button @click="showLog = false" class="mb-2" style="width: min-content;" variant="third">
        <i class="fas fa-angle-double-left mx-2"></i>
      </b-button>
      <ag-grid-vue class="ag-theme-alpine"
                  :getLocaleText="localeTextFunc"
                  :defaultColDef="defaultColumnDef"
                  :gridOptions="logGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="logColumnDefs"
                  :rowData="logs"
                  :suppressContextMenu="true"
                  :groupHeaderHeight="45"
                  :headerHeight="45"
                  :rowHeight="30"
                  :getRowId="params => params.data.id"
                  :excelStyles="excelStyles"
                  @firstDataRendered="onFirstDataRendered"
                  rowSelection="single"
                  style="width:100%;height:100%;">
        </ag-grid-vue>
    </div>
    <div v-show="!showLog" class="d-flex flex-column justify-content-start h-100">
      <b-overlay :show="editing" style="width:100%;height:100%;">
        <template #overlay>
          <div class="text-center">
            <i class="far fa-edit" style="font-size:3rem;"></i>
          </div>
        </template>
        <div class="d-flex flex-wrap w-100">
          <div class="d-flex col-6">
            <div class="d-flex" v-if="pciBatch.length">
              <strong>{{ $lang.PCI.Team.LabelBatchIncludedSites }}</strong>
            </div>
          </div>
          <div class="d-flex col-6">
            <div class="d-flex" v-if="pciBatchIgnore.length">
              <strong>{{ $lang.PCI.Team.LabelBatchIgnoredSites }}</strong>
            </div>
          </div>
          <div class="d-flex col-6">
            <div class="d-flex flex-wrap" v-if="pciBatch.length">
              <b-badge v-for="(p, index) in pciBatch" :key="index" class="m-1" style="height: min-content;" pill>{{ p.referencia }}<br>{{ p.idSite }}</b-badge>
            </div>
          </div>
          <div class="d-flex col-6">
            <div class="d-flex flex-wrap" v-if="pciBatchIgnore.length">
              <b-badge v-for="(p, index) in pciBatchIgnore" :key="index" class="m-1" variant="danger" style="height: min-content;" pill>{{ p.referencia }}<br>{{ p.idSite }}</b-badge>
            </div>
          </div>
        </div>
        <ag-grid-vue class="ag-theme-alpine"
                  :getLocaleText="localeTextFunc"
                  :defaultColDef="defaultColumnDef"
                  :gridOptions="teamsGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="columnDefs"
                  :rowData="list"
                  :suppressContextMenu="true"
                  :groupHeaderHeight="45"
                  :headerHeight="45"
                  :rowHeight="30"
                  :getRowId="params => params.data.id"
                  :excelStyles="excelStyles"
                  @firstDataRendered="onFirstDataRendered"
                  @cellDoubleClicked="onEditMember"
                  rowSelection="single"
                  style="width:100%;height:100%;">
        </ag-grid-vue>
      </b-overlay>

      <b-card class="mt-3" v-if="editable || editableBatch">
        <template #header>
          <div class="d-flex">
            <div class="flex-grow-1"><strong>{{$lang.PCI.Team.EditPanel}}</strong></div>
            <div class="card-actions">
              <b-link href="#" v-if="!editing" @click="onShowLog">
                <i class="fas fa-history" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing && (editable || editableBatch)" v-b-tooltip.hover :title="$lang.PCI.Team.TooltipAddRecord" @click="onNewMember">
                <i class="fas fa-plus" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing && pci.obraId" v-b-tooltip.hover title="Imprime" @click="printTeam">
                <i class="fa fa-print" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing && pci.obraId" v-b-tooltip.hover :title="$lang.Common.Buttons.ExportExcel" @click="onExportExcel">
                <i class="far fa-file-excel" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="editing && editable && isEditableMember" v-b-tooltip.hover :title="$lang.PCI.Team.TooltipSave" @click="onSave">
                <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-if="editing && editableBatch" v-b-tooltip.hover :title="$lang.PCI.Team.TooltipSave" @click="onSaveBatch">
                <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-if="editing && editable && isEditableMember" v-b-tooltip.hover :title="$lang.PCI.Team.TooltipCancel" @click="onCancelMember">
                <i class="fas fa-ban" style="font-size:1rem;color:var(--red);"></i>
              </b-link>
              <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.PCI.Team.TooltipLeave" @click="onCancelEditMember">
                <i class="fas fa-times" style="font-size:1rem;color:var(--danger);"></i>
              </b-link>
            </div>
          </div>
        </template>
        <form autocomplete="off" role="presentation" @submit.stop.prevent="" class="d-flex flex-wrap">
          <b-form-group :label="$lang.PCI.Team.LabelLabor" class="col-md-1">
            <b-form-select v-model="form.tipoMaoDeObra.value"
                            ref="txtTipoMaoDeObra"
                            :disabled="!inserting || !editing"
                            :options="form.tipoMaoDeObra.options">
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelEmployee" class="col-md-4">
            <autocomplete-z ref="employeeTypeahead"
                            iconClass="fas fa-user"
                            :serializer="s => s.codigo + ' - ' + s.nome"
                            :deboundLength="2"
                            :placeholder="$lang.Common.Buttons.Search"
                            :formField="form.funcionarioId"
                            :disabled="!inserting || !editing || form.tipoMaoDeObra.value === null || form.tipoMaoDeObra.value === 2"
                            v-on:search="onSearchEmployee"
                            v-on:changeCode="onChangeCodeEmployee"
                            v-on:hit="onLoadEmployee">
            </autocomplete-z>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelName" class="col-md-4">
            <b-form-input type="text"
                          autofocus
                          :disabled="!inserting || !editing || form.tipoMaoDeObra.value === null || form.tipoMaoDeObra.value === 1"
                          :state="form.nome.state"
                          v-model="form.nome.value" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelType" class="col-md-1">
            <b-form-select v-model="form.tipoServico.value"
                            :disabled="!editing"
                            :state="form.tipoServico.state"
                            :options="form.tipoServico.options">
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelFunction" class="col-md-2">
            <b-form-select v-model="form.funcaoObraID.value"
                            :disabled="!editing"
                            :state="form.funcaoObraID.state"
                            :options="funcaoObraOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelStartDate" class="col-md-2">
            <b-form-input type="date"
                          :disabled="!editing"
                          :state="form.inicioAtividades.state"
                          v-model="form.inicioAtividades.value" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelEndDate" class="col-md-2">
            <b-form-input type="date"
                          :disabled="!editing"
                          :state="form.terminoAtividades.state"
                          v-model="form.terminoAtividades.value" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Team.LabelObs" class="col-md-8">
            <b-form-input type="text"
                          :disabled="!editing"
                          :state="form.observacoes.state"
                          v-model="form.observacoes.value">
            </b-form-input>
          </b-form-group>
        </form>
      </b-card>
    </div>
  </b-modal>
  <!-- team_modal_end -->
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import { AgGridVue } from 'ag-grid-vue'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import moment from 'moment'
import gridMixin from '../../mixins/gridMixin'
import constructionMember from '@/shared/models/pci/constructionmember'
import memberForm from './member-form'
import ConstructionMemberRepository from '@/shared/http/repositories/business/constructionmember'
import WorkRepository from '@/shared/http/repositories/business/work'
import EmployeeRepository from '@/shared/http/repositories/business/employee'
import actionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import Roles from '@/shared/utils/roles'

export default {
  name: 'ConstructionTeam',
  mixins: [
    gridMixin,
    actionsForm
  ],
  components: {
    AgGridVue,
    AutocompleteZ
  },
  computed: {
    editable () {
      let editable = !this.pciBatch.length && this.pci.obraId && ((!this.pci.terminoReal && this.hasRole(this.roles.RW_OPER_PCI_TEAM)) || this.hasRole(this.roles.RW_OPER_PCI_ADM))
      return editable
    },
    editableBatch () {
      let editable = this.pciBatch.length > 0 && !this.pci.obraId
      return editable
    }
  },
  data () {
    return {
      list: [],
      pci: {},
      pciBatch: [],
      pciBatchIgnore: [],
      logs: [],
      editing: false,
      inserting: false,
      isEditableMember: false,
      data: constructionMember,
      form: memberForm,
      roles: Roles,
      teamsGridOptions: {},
      logGridOptions: {},
      showTeam: false,
      showLog: false,
      funcaoObraOptions: [],
      columnDefs: [
        {
          headerName: this.$lang.PCI.Team.LabelFunction,
          field: 'funcaoObra.nome',
          width: 250
        },
        {
          headerName: this.$lang.PCI.Team.LabelEmployee,
          field: 'funcionario.codigo',
          cellClass: 'justify-content-end',
          width: 100
        },
        {
          headerName: this.$lang.PCI.Team.LabelName,
          field: 'nome',
          width: 350
        },
        {
          headerName: this.$lang.PCI.Team.LabelPdr,
          type: 'booleanColumn',
          width: 90,
          valueGetter: param => {
            return param.data.funcionario && param.data.funcionario.cargo && param.data.funcionario.cargo.pdr
          }
        },
        {
          headerName: this.$lang.PCI.Team.LabelLabor,
          field: 'tipoMaoDeObra',
          width: 100,
          valueGetter: param => {
            return this.$lang.PCI.Team['LabelLabor_' + param.data.tipoMaoDeObra]
          }
        },
        {
          headerName: this.$lang.PCI.Team.LabelStartDate,
          field: 'inicioAtividades',
          type: 'dateColumn',
          width: 90
        },
        {
          headerName: this.$lang.PCI.Team.LabelEndDate,
          field: 'terminoAtividades',
          type: 'dateColumn',
          width: 90
        },
        {
          headerName: this.$lang.PCI.Team.LabelDaysAmount,
          cellClass: 'justify-content-end',
          width: 60,
          valueGetter: param => {
            if (param.data.inicioAtividades) {
              const DAY_UNIT_IN_MILLISECONDS = 24 * 3600 * 1000
              const initialDate = new Date(param.data.inicioAtividades)
              const finalDate = (param.data.terminoAtividades ? new Date(param.data.terminoAtividades) : new Date())
              initialDate.setHours(0, 0, 0, 0)
              finalDate.setHours(0, 0, 0, 0)
              const diffDays = finalDate.getTime() - initialDate.getTime()
              return (diffDays / DAY_UNIT_IN_MILLISECONDS + 1).toFixed(0)
            }
            return ''
          }
        },
        {
          headerName: this.$lang.PCI.Team.LabelStatus,
          field: 'status',
          width: 90,
          cellClassRules: {
            'statusCanceled': params => params.data.status === 0,
            'statusInactive': params => params.data.status === 1 && params.data.terminoAtividades !== null,
            'statusActive': params => params.data.status === 1 && params.data.terminoAtividades === null
          },
          valueGetter: param => {
            switch (param.data.status) {
              case 0: return this.$lang.PCI.Team.LabelStatus_Canceled
              case 1:
                if (param.data.terminoAtividades) {
                  return this.$lang.PCI.Team.LabelStatus_Inactive
                }
                return this.$lang.PCI.Team.LabelStatus_Active
            }
          }
        },
        {
          headerName: this.$lang.PCI.Team.LabelType,
          field: 'tipoServico',
          width: 90,
          valueGetter: param => {
            return this.$lang.PCI.Team['LabelType_' + param.data.tipoServico]
          }
        },
        {
          headerName: this.$lang.PCI.Team.LabelObs,
          field: 'observacoes',
          width: 300
        }
      ],
      logColumnDefs: [
        {
          headerName: this.$lang.Common.LabelDate,
          field: 'dataAcao',
          valueGetter: param => {
            return moment(param.data.dataAcao).format('DD/MM/yyyy HH:mm')
          },
          width: 150
        },
        {
          headerName: this.$lang.PCI.Team.LabelLogType,
          valueGetter: param => {
            return param.data.metodo === 'trg_update_terminoatividades' ? 'Automático' : param.data.metodo === 'PostObraMembro' ? 'Inclusão' : 'Alteração'
          },
          width: 150
        },
        {
          headerName: this.$lang.Common.LabelUser,
          field: 'contaAcao',
          width: 300
        },
        {
          headerName: this.$lang.PCI.Team.LabelName,
          field: 'nome',
          width: 300
        },
        {
          headerName: this.$lang.PCI.Team.LabelStatus,
          field: 'status',
          valueGetter: param => {
            switch (param.data.status) {
              case 0: return this.$lang.PCI.Team.LabelStatus_Canceled
              case 1:
                if (param.data.terminoAtividades) {
                  return this.$lang.PCI.Team.LabelStatus_Inactive
                }
                return this.$lang.PCI.Team.LabelStatus_Active
            }
          },
          width: 150
        },
        {
          headerName: this.$lang.PCI.Team.LabelFunction,
          field: 'funcaoObra',
          width: 250
        },
        {
          headerName: this.$lang.PCI.Team.LabelStartDate,
          field: 'inicioAtividades',
          type: 'dateColumn',
          width: 150
        },
        {
          headerName: this.$lang.PCI.Team.LabelEndDate,
          field: 'terminoAtividades',
          type: 'dateColumn',
          width: 150
        }
      ]
    }
  },
  methods: {
    printTeam () {
      loading.push()
      ConstructionMemberRepository.PrintTeam(this.pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            const binary = window.atob(response.data.data.replace(/\s/g, ''))
            const len = binary.length
            const buffer = new ArrayBuffer(len)
            const view = new Uint8Array(buffer)
            for (let i = 0; i < len; i++) {
              view[i] = binary.charCodeAt(i)
            }
            const blob = new Blob([view], {type: 'application/pdf'})
            const fileURL = URL.createObjectURL(blob)
            window.open(fileURL)
            // Alex pediu para imprimir em outra aba... a opção é abrir no mode de visualização de PDF
            // Caso queira volvar, o código está abaixo.
            // ---------------------------------------------------------------------------------------
            // const url = URL.createObjectURL(blob)
            // const iframe = document.createElement('iframe')
            // iframe.style.display = 'none'
            // iframe.src = url
            // const printDiv = document.getElementById('printDiv')
            // printDiv.innerHTML = ''
            // printDiv.appendChild(iframe)
            // iframe.contentWindow.print()
          }
        })
        .finally(() => loading.close())
    },
    setEditableMember () {
      this.isEditableMember = (this.pci.statuspdr >= 1 && (this.data && this.data.funcionario && this.data.funcionario.cargo && !this.data.funcionario.cargo.pdr) && this.hasRole(this.roles.RW_OPER_PCI_ADM)) || (this.pci.statuspdr < 1 && this.hasRole(this.roles.RW_OPER_PCI_TEAM))
      // this.isEditableMember = (this.pci.statuspdr >= 1 && (this.form.funcionarioId.value && this.form.funcionarioId.value.cargo && !this.form.funcionarioId.value.cargo.pdr)) || this.pci.statuspdr < 1
    },
    onFirstDataRendered (params) {
      params.api.sizeColumnsToFit()
    },
    onLoad () {
      this.searchFuncaoObra()
    },
    onClear () {
      Tools.ClearDataForms(this.form, this.data)
      this.setEditableMember()
      if (this.$refs.employeeTypeahead) {
        this.$refs.employeeTypeahead.clear()
      }
    },
    onUpdate () {
      loading.push()
      ConstructionMemberRepository.Update(this.data)
        .then(response => {
          this.teamsGridOptions.api.applyTransaction({ update: [response.data.data] })
          this.editing = false
          this.$emit('update', this.data)
          this.onClear()
        })
        .finally(() => loading.close())
    },
    onCreate () {
      if (this.isEditableMember) {
        loading.push()
        this.data.obraID = this.pci.obraId
        const codigo = this.list.length ? Math.max(...this.list.map(l => l.codigo)) : 0
        this.data.codigo = codigo + 1
        ConstructionMemberRepository.Create(this.data)
          .then(response => {
            if (response.data.code > 0) {
              this.list.push(response.data.data)
              this.editing = false
              this.inserting = false
              this.$emit('update', this.data)
              this.onClear()
            } else {
              toast.error(this.$lang.Common.Alerts.Error)
            }
          })
          .finally(() => loading.close())
      } else {
        toast.error('Não é permitido incluir um membrom com PDR após a liberação para avaliação.')
      }
    },
    onSearchEmployee (value) {
      loading.push()
      EmployeeRepository.GetAllByName(this.CompanySelected, value)
        .then((response) => {
          this.$refs.employeeTypeahead.data = response.data.data
        })
        .catch((err) => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onChangeCodeEmployee (value) {
      loading.push()
      EmployeeRepository.GetByCode(this.CompanySelected, value)
        .then(response => {
          if (response.data.code > 0) {
            this.$refs.employeeTypeahead.setValue(response.data.data)
            this.onLoadEmployee(response.data.data)
          }
        }).catch(err => {
          console.log(err)
        }).finally(() => loading.close())
    },
    onLoadEmployee (data) {
      if (data) {
        this.form.funcionarioId.value = data.id
        this.form.codigo.value = data.codigo
        this.form.obraID.value = this.pci.obraId
        this.form.nome.value = data.nome
        this.form.inicioAtividades.value = moment().format('YYYY-MM-DD')
        this.setEditableMember()
      }
    },
    searchFuncaoObra () {
      loading.push()
      ConstructionMemberRepository.GetAllFunctions()
        .then((response) => {
          if (response.data.code > 0) {
            this.funcaoObraOptions = response.data.data.map(r => {
              return {value: r.id, text: r.nome}
            })
          }
          loading.close()
        })
        .catch((err) => {
          console.log(err)
          loading.close()
        })
    },
    show (pci) {
      this.pci = pci

      loading.push()

      WorkRepository.GetTeam(pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            this.list = response.data.data.map(d => {
              d.inicioAtividades = d.inicioAtividades ? moment(d.inicioAtividades).format('yyyy-MM-DD') : null
              d.terminoAtividades = d.terminoAtividades ? moment(d.terminoAtividades).format('YYYY-MM-DD') : null
              return d
            })
            this.showTeam = true
            this.$nextTick(() => {
              this.onClear()
            })
          }
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => loading.close())
    },
    showBatch (pcis) {
      if (pcis) {
        pcis.forEach(p => {
          if (p.terminoReal) {
            this.pciBatchIgnore.push({ referencia: p.referencia, idSite: p.idSite, motivo: 'COP' })
          } else if (p.coordenador || p.engenheiro || p.mestre || p.supervisor) {
            this.pciBatchIgnore.push({ referencia: p.referencia, idSite: p.idSite, motivo: 'TEAM' })
          } else if (p.possuiCandidato && !p.candidatoSel && p.candidato) {
            this.pciBatchIgnore.push({ referencia: p.referencia, idSite: p.idSite, motivo: 'CAND' })
          } else {
            this.pciBatch.push(p)
          }
        })
        this.showTeam = true
      }
    },
    onSaveBatch () {
      const self = this
      const promises = [Promise.resolve()]
      if (Tools.ValidateForms(this.form, this.data, self, toast)) {
        let errors = false
        let first = true
        this.pciBatch.forEach(p => {
          this.data.id = '00000000-0000-0000-0000-000000000000'
          this.data.status = 1
          loading.push()
          this.data.obraID = p.obraId
          const codigo = this.list.length ? Math.max(...this.list.map(l => l.codigo)) : 0
          this.data.codigo = codigo + 1
          promises.push(
            ConstructionMemberRepository.Create(this.data)
              .then(response => {
                if (response.data.code > 0) {
                  if (first) this.list.push(response.data.data)
                  first = false
                  this.$emit('update', this.data)
                } else {
                  errors = true
                }
              })
              .finally(() => loading.close())
          )
        })
        Promise.all(promises)
          .then(() => {
            if (!errors) {
              this.editing = false
              this.inserting = false
              this.onClear()
            }
          })
      }
    },
    onExportExcel () {
      this.teamsGridOptions.api.exportDataAsExcel()
    },
    onNewMember () {
      this.editing = true
      this.inserting = true
      this.form.codigo.value = 0
    },
    onEditMember (params) {
      if (this.editable) {
        this.editing = true
        this.inserting = false
        Tools.SetValueInForm(this.form, this.data, params.data)
        this.form.funcionarioId.code = params.data.funcionario ? params.data.funcionario.codigo : null
        this.form.obraID.value = this.pci.obraId
        this.setEditableMember()
        if (params.data.funcionario) {
          this.$refs.employeeTypeahead.setValue(params.data.funcionario)
        }
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.$refs.txtTipoMaoDeObra.$el.focus()
          })
        })
      }
    },
    onCancelMember () {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])

      this.$bvModal.msgBoxConfirm([messageVNode], {
        title: this.$lang.Common.ConfirmCancel,
        centered: true,
        okTitle: this.$lang.Yes,
        cancelTitle: this.$lang.No,
        headerClass: 'justify-content-center'
      })
        .then((value) => {
          if (value) {
            this.form.status.value = 0
            this.onSave()
          }
        })
    },
    onCancelEditMember () {
      this.editing = false
      this.onClear()
    },
    onShowLog () {
      ConstructionMemberRepository.GetLogs(this.pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            this.logs = response.data.data
            this.showLog = true
          }
        })
    },
    onClose () {
      this.showTeam = false
      this.$emit('close', this.list)
    }
  }
}
</script>

<style scoped>
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-principal .modal-body {
  height: calc(100vh - 140px);
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
* >>> .modal-content {
  border-radius: 25px;
}
.form-group {
  padding-left: 0;
  margin-top: 0.5rem;
}
* >>> .form-control {
  min-height: unset;
}
* >>> .statusActive {
  background-color: #0ca8308c;
}
* >>> .statusInactive {
  background-color: #ffc10785;
}
* >>> .statusCanceled {
  background-color: #e91a2e9e;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/construction/constructionTeam.vue